export const districtEntries = [
  {
    addRemoveCount: true,
    breakpoint: 3,
  },

  // { formTitle: true, labelText: 'TAS Blood Survey' },
  // {
  //   // value: '',
  //   textField: true,
  //   entryName: 'eu_name',
  //   placeholder: 'EU Name',
  //   textInputType: 'default',
  //   breakpoint: 4,
  //   validation: { isRequired: true },
  // },
  {
    ComboBox: true,
    default: true,
    isCombined: true,
    entryName: 'eu_name',
    placeholder: 'EU Name',
    data: [],
  },
  {
    value: '',
    textField: true,
    // populationField: true,
    // disabled: true,
    entryName: 'population_under_eu',
    placeholder: 'Population Under EU',
    textInputType: 'number',
    breakpoint: 4,
    validation: { isRequired: true, min: 0 },
  },
  {
    isEmptySpace: true,
    breakpoint: 4,
  },

  {
    value: '',
    date: true,
    disabled: true,
    entryName: 'date_completed',
    placeholder: 'TAS Survey Date Completed (Auto Populate)',
    breakpoint: 4,
    validation: { isRequired: true },
  },
  {
    value: '',
    date: true,
    disabled: true,
    entryName: 'date_planned',
    placeholder: 'Date Planned by State (Auto Populate)',
    breakpoint: 4,
    validation: { isRequired: true },
  },
  {
    value: '',
    date: true,
    disabled: true,
    entryName: 'date_proposed',
    placeholder: 'Date Proposed NVBDCP (Auto Populate)',
    textInputType: 'default',
    breakpoint: 4,
    validation: { isRequired: true },
  },

  {
    value: '',
    textField: true,
    entryName: 'sample_size',
    placeholder: 'Target Sample Size',
    textInputType: 'number',
    breakpoint: 4,
    validation: { isRequired: true, min: 0 },
  },
  {
    value: '',
    textField: true,
    entryName: 'number_of_persons_examined',
    placeholder: 'Number of People Examined',
    textInputType: 'number',
    breakpoint: 4,
    validation: { isRequired: true, min: 0 },
  },
  {
    value: '',
    textField: true,
    entryName: 'number_of_persons_positive',
    placeholder: 'Number of People Positive',
    textInputType: 'number',
    breakpoint: 4,
    validation: { isRequired: true, min: 0 },
  },
  {
    value: '',
    textField: true,
    entryName: 'number_of_invalid_test',
    placeholder: 'Number of Invalid Test',
    textInputType: 'number',
    breakpoint: 4,
    validation: { isRequired: true, min: 0 },
  },
  {
    value: '',
    textField: true,
    entryName: 'critical_cut_off',
    placeholder: 'Critical Cut Off',
    textInputType: 'number',
    breakpoint: 4,
    validation: { isRequired: true, min: 0 },
  },
  {
    isEmptySpace: true,
    breakpoint: 4,
  },
  {
    divider: true,
    fullView: true,
  },
];

export const districtdefaultValues = {
  eu_name: '',
  population_under_eu: 100,
  date_completed: '',
  date_planned: '',
  date_proposed: '',
  sample_size: '',
  number_of_persons_examined: '',
  number_of_persons_positive: '',
  number_of_invalid_test: '',
  critical_cut_off: '',
};
